const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    jobCount: (n) =>
        __nx('{n} job', '{n} job', n, { n }),
    searching: () =>
        __('Søger..'),
    fieldPlaceholder: () =>
        __('Søg efter virksomhed'),
};
